import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.581 9.317c-.526-.058-.557-.764-.55-.983a5.68 5.68 0 00-.147.902c-.025.466.095.893.382 1.045.517.275 1.045-.295 1.355-.704l2.876-3.8-3.184 3.162c-.268.264-.528.399-.732.378z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.815 3.037l1.354 2.348a2.5 2.5 0 01-.915 3.414L6.2 12.872a4.693 4.693 0 01-2.344.628H2.494c-.996 0-1.37-1.301-.528-1.831a3.827 3.827 0 001.275-1.325l3.67-6.36a4.172 4.172 0 005.11-2.95"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.976c-.789-.087-.836-1.146-.826-1.475-.099.454-.197.908-.22 1.354-.037.699.143 1.339.573 1.567.775.413 1.567-.442 2.032-1.056l4.315-5.701-4.777 4.744c-.402.396-.791.598-1.097.567z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.222 4.556l2.032 3.52a3.75 3.75 0 01-1.372 5.123L9.3 19.308a7.039 7.039 0 01-3.517.942H3.742c-1.494 0-2.057-1.952-.793-2.747a5.74 5.74 0 001.913-1.987l5.506-9.54a6.258 6.258 0 007.665-4.424"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M38.443 9.111l4.064 7.042a7.499 7.499 0 01-2.744 10.244L18.601 38.615a14.077 14.077 0 01-7.034 1.884H7.483c-2.988 0-4.114-3.904-1.586-5.494a11.48 11.48 0 003.826-3.974l11.012-19.08c6.678 1.79 13.54-2.172 15.33-8.848"
  }))
};
export var Shoe = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});